module.exports = __webpack_public_path__ + "img/linux.baaa1463.svg";